<template>
  <div v-if="fixed" class="fixed-item">
    {{ data }}
  </div>
  <div v-else class="group-item">
    <div class="left-icon" @click="removeItem">
      <feather-icon icon="MinusIcon" size="20"/>
    </div>
    <div class="body">
      <ml-input class="w-full" v-model="data"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupItem",
  props: {
    value: String,
    fixed: Boolean,
  },
  computed: {
    data: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    removeItem() {
      this.$emit('removeItem', this.value);
    }
  }
}
</script>

<style scoped lang="scss">
.fixed-item {
  text-align: center;
  font-weight: 500;
  padding: 1rem;
}
.group-item {
  display: grid;
  grid-template-columns: auto 1fr;

  .body,
  .left-icon,
  .right-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 0.675rem;

    .feather-icon {
      transition: all ease 0.3s;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .body {
    padding: 0.375rem;
  }

  .left-icon {
    color:#7E72F2;
  }
}
</style>
